import MediaTypes from './components/MediaTypes';

export default MediaTypes;
